<app-pan-card [isPageContainer]="true" header="You Need Permission">
  @switch (accessType()) {
    @case ("theft-report") {
      <div class="ml-auto mr-auto text-center my-5 max-w-[70%]">
        Thank you for authenticating! You're trying to access the suspicious incident report for <strong>{{ displayName() }}</strong
        >. You need to request access to view this report.
      </div>

      <div class="flex justify-center items-center gap-2">
        @if (isCheckingAccess()) {
          <app-pan-spinner size="md"></app-pan-spinner>
          <span class="text-sm text-gray-500">Checking if you've been granted access...</span>
        } @else {
          <div class="my-2"></div>
        }
      </div>

      @if (hasAccess()) {
        <div class="flex justify-center items-center gap-1">
          <mat-icon class="text-success">check</mat-icon>
          <span>Granted access</span>
        </div>
      }

      <div class="flex gap-2 justify-center mt-3">
        <app-pan-button
          color="primary"
          (click)="requestAccess()"
          [disabled]="hasRequestedAccess() || isPendingRequestAccess()"
          [state]="isPendingRequestAccess() ? 'loading' : 'default'"
          >Request Access</app-pan-button
        >
        <app-pan-button (click)="switchAccount()">Switch Account</app-pan-button>
      </div>
    }
  }
</app-pan-card>
